module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0113.jpg?v=5c1df975";